import { OutputValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/OutputValidator';
import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
export class OutputViewModelValidator extends Validator {
    constructor() {
        super();
        this.outputValidator = new OutputValidator();
    }
    validate(model) {
        this.outputValidator.validate(model);
    }
}
